/* eslint-disable no-console */

import { register } from 'register-service-worker'

// Register service worker in all environments (needed for push notifications)

const swUrl =
  process.env.NODE_ENV === 'development'
    ? `${process.env.BASE_URL}sw.js`
    : `${process.env.BASE_URL}service-worker.js`

console.log('Version: ', process.env.VUE_APP_TIMESTAMP)
console.log(`[PWA] Registering service worker: ${swUrl} (env=${process.env.NODE_ENV})`)
register(swUrl, {
  ready() {
    console.log(
      'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
    )
  },
  registered() {
    console.log('Service worker has been registered.')
  },
  cached() {
    console.log('Content has been cached for offline use.')
  },
  updatefound() {
    console.log('New content is downloading.')
  },
  updated() {
    console.log('New content is available; Refresh...')
    setTimeout(() => {
      window.location.reload(true)
    }, 1000)
  },
  offline() {
    console.log('No internet connection found. App is running in offline mode.')
  },
  error(error) {
    console.error('Error during service worker registration:', error)
  }
})
